import Vue from 'vue'
import Router from 'vue-router'
import Meta from 'vue-meta'

import firebase from 'firebase'
import store from '../store'

import globals from '@/globals'

import authRoutes from './auth'
import managementRoutes from './management'
import portalRoutes from './portal'

Vue.use(Router)
Vue.use(Meta)

const ROUTES = [
  // Default route
  { path: '', redirect: '/zarzadca/portale' }
]
  .concat(authRoutes)
  .concat(managementRoutes)
  .concat(portalRoutes)

const router = new Router({
  base: '/',
  mode: 'history',
  routes: ROUTES
})

router.afterEach(() => {
  // Remove initial splash screen
  const splashScreen = document.querySelector('.app-splash-screen')
  if (splashScreen) {
    splashScreen.style.opacity = 0
    setTimeout(() => splashScreen.parentNode && splashScreen.parentNode.removeChild(splashScreen), 300)
  }

  // On small screens collapse sidenav
  if (window.layoutHelpers && window.layoutHelpers.isSmallScreen() && !window.layoutHelpers.isCollapsed()) {
    setTimeout(() => window.layoutHelpers.setCollapsed(true, true), 10)
  }

  // Scroll to top of the page
  globals().scrollTop(0, 0)
})

router.beforeEach((to, from, next) => {
  // Auth
  if (to.matched.some(record => record.meta.auth)) {
    if (!store.getters.isLogged) {
      return next({
        path: '/logowanie'
      })
    } else {
      const { authorize } = to.meta
      if (authorize) {
        // Check role
        if (!authorize.includes(store.state.user.role)) {
          return next({
            path: '/logowanie'
          })
        }
      }
    }
  }
  // Set loading state
  document.body.classList.add('app-loading')
  // Add tiny timeout to finish page transition
  setTimeout(() => next(), 10)
})

export default router
